import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { merge, Subscription } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { environment } from '@env/environment';
import { Logger, JwtService } from '@app/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { Spinkit } from 'ng-http-loader';

const log = new Logger('App');
export let browserRefresh = true;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  public spinkit = Spinkit;

  isRefresh: boolean;
  subscription: Subscription;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthenticationService,
    private titleService: Title,
    private jwtService: JwtService) {
  }

  ngOnInit() {
    // Setup logger
    if (environment.production) {
      Logger.enableProductionMode();
    }

    let context = this;

    window.addEventListener("click", function (e) {
      // e.target was the clicked element
      let target: any = e.target;
      if (target && target.nodeName == "IMG") {
        let targetObj = new String(target);
        if (targetObj && targetObj.indexOf('http://www.wctpension.org/') == -1) {
          target = target.parentNode;
        }
      }
      if (target && target.nodeName == "A") {
        let targetValue = new String(target);
        if (targetValue.indexOf('http://www.wctpension.org/') != -1) {
          browserRefresh = false;
        } else {
          browserRefresh = true;
        }
      }
    });

    window.addEventListener("beforeunload", function (e) {
      let currentUser = context.jwtService.getLoggedInUser();
      if (currentUser && !browserRefresh) {
        console.log('Logging Out : ' + currentUser);
        context.logoutOnClose();
      } else {
        console.log('Logout not called : ' + currentUser);
      }
    });

    window.addEventListener("onunload", function (e) {
      let currentUser = context.jwtService.getLoggedInUser();
      if (currentUser && !browserRefresh) {
        console.log('Logging Out : ' + currentUser);
        context.logoutOnClose();
      } else {
        console.log('Logout not called : ' + currentUser);
      }
    });

    log.debug('init');
    // Setup translations
    // this.i18nService.init(environment.defaultLanguage, environment.supportedLanguages);
    const onNavigationEnd = this.router.events.pipe(filter(event => event instanceof NavigationEnd));
    // Change page title on navigation or language change, based on route data
    merge(onNavigationEnd)
      .pipe(
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(event => {
        const title = event['title'];
        if (title) {
          this.titleService.setTitle(title);
        }
      });
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
  }
  logoutOnClose() {
    this.authService.logout();
    this.jwtService.destroyToken();
    this.jwtService.destroyParticipantId();
    localStorage.clear();
  }
}